var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsers = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.83 2.85)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 4.50167,
  cy: 2.82764,
  r: 2.32764,
  stroke: "white",
  strokeOpacity: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10.5042,
  cy: 3.48791,
  r: 1.66736,
  stroke: "white",
  strokeOpacity: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.5 10.4908V9.81255C0.5 8.34527 1.68916 7.15611 3.15644 7.15611H5.84689C7.31417 7.15611 8.50333 8.34527 8.50333 9.81255V10.4908",
  stroke: "white",
  strokeOpacity: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5042 7.15611H11.2391C12.7064 7.15611 13.8956 8.34527 13.8956 9.81255V10.4908",
  stroke: "white",
  strokeOpacity: 0.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))));
export default SvgUsers;